export default {
  firmBio: "profile/firmBio/create",
  getfirmBio: "profile/firmBio",
  update: "profile/firmBio/update",
};
